var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionNoAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maybe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maybe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-191-+-Stroke-192",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#FDBB48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,18 C36,27.9392727 27.9392727,36 18,36 C8.05745455,36 0,27.9392727 0,18 C0,8.05745455 8.05745455,0 18,0 C27.9392727,0 36,8.05745455 36,18 L36,18 Z",
    id: "Stroke-191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,19 L28,19",
    id: "Stroke-192"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionNoAnimation);
export default __webpack_public_path__ + "static/media/inspection_no_animation.79e14df49bcd77eea8b71f88cfa7ae17.svg";
export { ForwardRef as ReactComponent };